// Esta blackList es para variables que vienen en los logs salidas de no se sabe donde
const _propsBlackList = [
  "__general",
  "__kids",
  "__price",
  "_id",
  "conversionRate",
  "conversionTime",
  "creation",
  "customFee",
  "customPrice",
  "exceptions",
  "expense",
  "modification",
  "recommendedTransportation",
  "reservations",
  "time",
  "transport",
  "transportationOptions",
  "usar gasto de gestion modificado",
  "useCustomPrice",
].reduce(
  (accum, key) => ({ ...accum, [key]: true }),
  {}
)

const propsBlackList = _propsBlackList

export default propsBlackList
